import React, { useState } from "react";
import { Container, Row, Col, Form, FormGroup, Label, Input } from "reactstrap";
import "./Contact.css";
import * as emailjs from "emailjs-com";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const { name, email, message } = formData;

  const resetForm = () => {
    setFormData({
      name: "",
      email: "",
      message: "",
    });
  };

  const onChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const onSubmit = (e) => {
    e.preventDefault();
    console.log(formData);
    console.log("form submitted");

    var SERVICE_ID = "service_qdlw33x";
    var TEMPLATE_ID = "template_xc2y67d";
    var USER_ID = "user_4JEblKGUlOUD74wFkexDE";

    let templateParams = {
      from_name: email,
      to_name: "elijahobominuru@gmail.com",
      message_html: message,
    };

    emailjs.send(SERVICE_ID, TEMPLATE_ID, templateParams, USER_ID).then(
      function (response) {
        console.log(response.status, response.text);
        alert("message sent");
      },
      function (err) {
        console.log(err);
      }
    );

    resetForm();
  };

  return (
    <div className='contact' id='contact'>
      <Container>
        <Row>
          <Col xs='12' md='6' className='m-auto'>
            <h1>Interested in collaborating?</h1>
            <p>
              If you have an application you are interested in developing, a
              feature that you need built or a project that need coding, I’d
              love to help you with it.
            </p>
          </Col>
        </Row>
        <Row>
          <Col xs='12' md='6' className='m-auto'>
            <Form onSubmit={(e) => onSubmit(e)}>
              <Row form>
                <Col md={6}>
                  <FormGroup>
                    <Label for='exampleEmail'>Name</Label>
                    <Input
                      type='text'
                      name='name'
                      id='exampleEmail'
                      value={name}
                      onChange={(e) => onChange(e)}
                      required
                      //   placeholder='with a placeholder'
                    />
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <Label for='examplePassword'>Email</Label>
                    <Input
                      type='email'
                      name='email'
                      id='examplePassword'
                      value={email}
                      onChange={(e) => onChange(e)}
                      required
                      //   placeholder='password placeholder'
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col md={12}>
                  <FormGroup>
                    <Label for='exampleText'>Message</Label>
                    <Input
                      type='textarea'
                      className='textarea'
                      name='message'
                      // id='exampleText'
                      value={message}
                      onChange={(e) => onChange(e)}
                      required
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col md={12}>
                  <input
                    type='submit'
                    className='button'
                    value='Get in touch'
                  />
                </Col>
              </Row>
            </Form>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Contact;
